
import Navigation from '../components/utils/Navigation';
import { fromNow, diffDate } from '../utils/utilitiesmodule';
import { iconsToModuleEnabled, iconsToModuleDisabled } from "../utils/objects.js";
import PCRemoteLink from '../components/utils/PCRemoteLink.vue';
import PCLicenseLink from '../components/utils/PCLicenseLink.vue';
import PCBackupLink from '../components/utils/PCBackupLink.vue';
import NoDataAvailable from '../components/utils/NoDataAvailable';
import PCLink from "../components/utils/PCLink";
import IperiusONEIcon from '../components/utils/IperiusONEIcon.vue';

const FILTERS_STORAGE_KEY = "computersFilters";
const PERSISTED_FILTER_KEYS = [
    "pcName",
    "id_group",
    "limit",
    "favorites",
    "excludeRemovedComputers",
    "showOnlyOne",
    "order",
    "sort"
];

export default {
    name: "Computers",
    components: {
        Navigation,
        PCLink,
        PCRemoteLink,
        PCLicenseLink,
        PCBackupLink,
        NoDataAvailable,
        IperiusONEIcon
        //Tile
    },
    data() {
        return {
            computers: null,
            filteredcomputers: null,
            connectionPctimeInterval: null,
            groups: null,
            licenses: {},
            filters: {
                backupName: '',
                pcName: '',
                offset: 0,
                lastresult: '',
                status: '',
                dt_inf: '',
                dt_sup: '',
                id_group: '',
                id_pc: '',
                id_host: '',
                id_user: '',
                limit: 25,
                index: 0,
                activitystatus: '',
                favorites: '',
                excludeRemovedComputers: true,
                showOnlyOne: false,
                order: "name",
                sort:"asc"

            },
            has_more: false,
            orderBy:"name|asc"
        }
    },
    computed: {
        licensesList() {
            this.licenses = this.$session.getLicenses();
            const result = [];

            // Backup Licenses
            if (this.licenses.backup) {
                result.push(...this.licenses.backup);
            }

            // Monitoring Licenses
            if (this.licenses.monitoring) {
                result.push(...this.licenses.monitoring);
            }

            // Remote Licenses
            /*if (this.licenses.remote) {
    result.push(...this.licenses.remote);
            }*/

            return result;
        }
    },
    created() {
        console.log("Computers created");
    },
    beforeUnmount() {
        console.log("Computers beforeUnmount");
    },
    unmounted() {
        console.log("Computers unmounted");
    },
    mounted() {
        this.groups = this.$session.getGroups();
        this.restoreFilters();
        this.getDevices();
    },
    beforeDestroy() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
    },
    methods: {

        applyFilters() {
            this.filters.index = 0;
            this.filters.offset = 0;
            this.saveFilters();
            this.getDevices();
        },

        getFiltersStorageKey() {
            const userId = this.$root.authObj && this.$root.authObj.id_user;
            return `${FILTERS_STORAGE_KEY}:${userId || "default"}`;
        },

        restoreFilters() {
            try {
                const savedFilters = JSON.parse(localStorage.getItem(this.getFiltersStorageKey()));
                if (!savedFilters || typeof savedFilters !== "object") return;

                PERSISTED_FILTER_KEYS.forEach(key => {
                    if (Object.prototype.hasOwnProperty.call(savedFilters, key)) {
                        this.filters[key] = savedFilters[key];
                    }
                });
                this.orderBy = `${this.filters.order}|${this.filters.sort}`;
            } catch (error) {
                console.warn("Unable to restore computer filters", error);
            }
        },

        saveFilters() {
            const filtersToSave = {};
            PERSISTED_FILTER_KEYS.forEach(key => {
                filtersToSave[key] = this.filters[key];
            });
            localStorage.setItem(this.getFiltersStorageKey(), JSON.stringify(filtersToSave));
        },

        async getDevices() {
            var devicesList = await this.$api.getDevices(this.filters);
            if (devicesList == null) {
                //Se la chiamata fosse andata a buon fine, computers sarebbe stato una mappa idPC : pc 
                this.computers = {};
                this.has_more = false;
                return;
            }
            var pcs = devicesList.computers;

            this.computers = pcs.toMap("id");// pcs.reduce((obj, pc) => ({ ...obj, [pc.id]: pc }), {});
            //Imposto che il timer di remote deve controllare questi computer
            //Per ottimizzare lo spazio, i pc della mappa sono nella versione lite
            this.has_more = devicesList.has_more;
        },


        setFavorite: function (computer) {
            this.$api.setFavorite(computer.id, !computer.is_favorite).then(response => {
                if (response.status == 200) {
                    computer.is_favorite = !computer.is_favorite;

                }
            });
        },

        getFeatureIconClass: function (status, feature_id) {
            if (status == 'on') {
                return iconsToModuleEnabled[feature_id] || '/assets/img/icons/license_icons/folder_black.svg'; // default icona
            } else {
                return iconsToModuleDisabled[feature_id] || '/assets/img/icons/license_icons/folder_black.svg'; // dafault icona
            }
        },


        isComputerInLicense(computerId, license) {
            if (!license.computers) return false;
            return license.computers.some(comp => comp.id == computerId);

        },

        fromNow(date) {
            if (date == null || date == "") return ""
            return fromNow(date, this.$moment);
        },
        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },

        openBackupView(idBackup) {
            this.idBackupInView = idBackup;
            this.$root.$emit("OPENBACKUPVIEW", idBackup);
        },
        filteredList(data) {
            this.filteredcomputers = this.computers;
            this.filteredcomputers = this.computers.filter((computer) => {
                return computer.name.toLowerCase().includes(data.toLowerCase()) || computer.description.toLowerCase().includes(data.toLowerCase())
            });
        },
        changeOrder(){
            var arr = this.orderBy.split("|")
            this.filters.order=arr[0];
            this.filters.sort=arr[1];
        }

    }
}
